import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  ConvenioDetailsState,
  ConvenioDetailsAction,
  ConvenioDetailsReducer,
} from './convenio-details-reducer';

const initialState: ConvenioDetailsState = {
  convenioDetails: null,
  loading: false,
  error: null,
};

const ConvenioDetailsStateContext = createContext<ConvenioDetailsState | undefined>(undefined);
const ConvenioDetailsDispatchContext = createContext<React.Dispatch<ConvenioDetailsAction> | undefined>(undefined);

interface ConvenioDetailsProviderProps {
  children: ReactNode;
}

export const ConvenioDetailsProvider: React.FC<ConvenioDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(ConvenioDetailsReducer, initialState);

  return (
    <ConvenioDetailsStateContext.Provider value={state}>
      <ConvenioDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </ConvenioDetailsDispatchContext.Provider>
    </ConvenioDetailsStateContext.Provider>
  );
};

export const useConvenioDetailsState = (): ConvenioDetailsState => {
  const context = useContext(ConvenioDetailsStateContext);
  if (context === undefined) {
    throw new Error('useConvenioDetailsState must be used within a ConvenioDetailsProvider');
  }
  return context;
};

export const useConvenioDetailsDispatch = (): React.Dispatch<ConvenioDetailsAction> => {
  const context = useContext(ConvenioDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useConvenioDetailsDispatch must be used within a ConvenioDetailsProvider');
  }
  return context;
};
